import { http, HttpResponse } from "msw";
import { generateInviteCode, getState, updateState } from "../state";

export const inviteCodeHandlers = [
  http.get("/api/v1/enrollment/pools", () => {
    const state = getState();
    return HttpResponse.json({
      pools: state.inviteCodes.map((c) => ({
        invitecode: c.invitecode,
        active: c.active,
        owner_cs: c.owner_cs,
        created: c.created,
      })),
    });
  }),

  http.post("/api/v1/enrollment/invitecode/create", () => {
    const state = getState();
    const newCode = generateInviteCode();
    state.inviteCodes.push({
      invitecode: newCode,
      active: true,
      owner_cs: state.currentCallsign || "JanneJaeger",
      created: new Date().toISOString(),
    });
    updateState({ inviteCodes: state.inviteCodes });
    return HttpResponse.json({ invite_code: newCode });
  }),

  http.delete("/api/v1/enrollment/invitecode/:code", ({ params }) => {
    const { code } = params;
    const state = getState();
    const newCodes = state.inviteCodes.filter((c) => c.invitecode !== code);
    updateState({ inviteCodes: newCodes });
    return HttpResponse.json({ invite_code: code as string });
  }),

  http.put("/api/v1/enrollment/invitecode/deactivate", async ({ request }) => {
    const body = (await request.json()) as { invite_code: string };
    const state = getState();
    const code = state.inviteCodes.find(
      (c) => c.invitecode === body.invite_code,
    );
    if (code) {
      code.active = false;
      updateState({ inviteCodes: state.inviteCodes });
    }
    return HttpResponse.json({ success: true });
  }),

  http.put("/api/v1/enrollment/invitecode/activate", async ({ request }) => {
    const body = (await request.json()) as { invite_code: string };
    const state = getState();
    const code = state.inviteCodes.find(
      (c) => c.invitecode === body.invite_code,
    );
    if (code) {
      code.active = true;
      updateState({ inviteCodes: state.inviteCodes });
    }
    return HttpResponse.json({ success: true });
  }),
];
